export const LabelFree = () => {
  return <label className="nj-label-free" data-e2e="label-tier-free">Basic</label>;
};
